import React from 'react';
import './Button.scss';
import {Link, useLocation} from 'react-router-dom';

type ButtonProps = {
    text : string
    uri? : string
    additionalClass? : string
    action? : () => void
}

export default function Button({text, uri, additionalClass, action} : ButtonProps) {
    const location = useLocation();
    const cssClass = 'career-model__button' + (additionalClass ? ' ' + additionalClass : '');

    if (uri) {
        return <Link to={uri} className={cssClass}
                     state={{backgroundLocation: location}}>
            {text}
        </Link>
    }

    return (
        <div onClick={action} className={cssClass}>
            {text}
        </div>
    );
};
